import { render, staticRenderFns } from "./SupplierThingsPage.vue?vue&type=template&id=0954e995&scoped=true&"
import script from "./SupplierThingsPage.vue?vue&type=script&lang=ts&"
export * from "./SupplierThingsPage.vue?vue&type=script&lang=ts&"
import style0 from "./SupplierThingsPage.vue?vue&type=style&index=0&id=0954e995&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0954e995",
  null
  
)

export default component.exports